import React, { useState } from 'react';
import cx from 'classnames';

import { ReactComponent as PlayIcon } from '../../../../../client/assets_seller/landingpages/sell_my_car/icon-youtube.svg';

import { ContentSectionProps } from './ContentSection.types';

import styles from './ContentSection.module.scss';

export const ContentSection = ({
  contentBody,
  imgAlt = '',
  imgSrc = '',
  isVideo = false,
  reverse = false,
  theme = 'white',
  title,
  vidSrc = '',
  ...restProps
}: ContentSectionProps) => {
  const [showVideo, setShowVideo] = useState(false);
  const handleOnClick = () => setShowVideo(true);

  const generateImg = (imgSource: ContentSectionProps['imgSrc']) => {
    if (!imgSource) {
      return null;
    }

    if (!isVideo) {
      return (
        React.isValidElement(imgSource) ? imgSource
          : <img
            alt={imgAlt}
            height='440'
            loading='lazy'
            src={imgSource as string}
            width='440'
          />
      );
    }

    return (
      <>
        {showVideo ? (
          <iframe
            allowFullScreen
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            data-testid="youtube-vid-player"
            height="269"
            src={vidSrc}
            title={imgAlt}
            width="100%"
          />
        ) : (
          <button className={styles.thumbnail} onClick={handleOnClick}>
            {imgSource}
            <PlayIcon className={ styles.playIcon } />
          </button>
        )}
      </>

    );
  };

  return (
    <div
      className={cx(styles.component, styles[theme], {
        [styles.reverse]: reverse,
        [styles.video]: isVideo,
      })}
      {...restProps}
    >
      {generateImg(imgSrc)}
      <div className={cx(styles.contentArea, { [styles.noImage]: !imgSrc })}>
        <h3>{title}</h3>
        <div dangerouslySetInnerHTML={{ __html: contentBody }} className={cx(styles.contentBody)} />
      </div>
    </div>
  );
};
